import { render } from "./Agreement.vue?vue&type=template&id=5189b970"
import script from "./Agreement.vue?vue&type=script&lang=js"
export * from "./Agreement.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/v1/Agreement.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5189b970"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5189b970', __exports__)) {
    api.reload('5189b970', __exports__)
  }
  
  module.hot.accept("./Agreement.vue?vue&type=template&id=5189b970", () => {
    api.rerender('5189b970', render)
  })

}


export default __exports__